import { Box, BoxProps, SxProps, Typography, TypographyPropsVariantOverrides } from "@mui/material";
import { TypographyVariant } from "@mui/material/styles/createTypography";
import { OverridableStringUnion } from "@mui/types";
import { resolveMprcMargin } from "components/styles/resolvers";
import * as React from "react";

interface IProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode | React.ReactNode[];
    titleVariant?: OverridableStringUnion<TypographyVariant | 'inherit', TypographyPropsVariantOverrides>;
    titleSx?: SxProps;
    subtitleSx?: SxProps;
    margin?: MprcMargin;
}

type Props = IProps & Omit<BoxProps, "title" | "marginBottom" | "marginTop" | "marginLeft" | "marginRight">;

export const MprcFormSubHeader: React.FC<Props> = (props) => {
    const { title, subtitle, titleSx, subtitleSx, margin = "none", titleVariant = "h3" } = props;
    return (
        <Box sx={(theme) => ({ marginBottom: resolveMprcMargin(theme, margin) })}>
            <Typography variant={titleVariant} sx={titleSx}>
                {title}
            </Typography>
            {
                subtitle &&
                <Typography variant="caption" sx={subtitleSx}>
                    {
                        Array.isArray(subtitle)
                            ? subtitle.map((s, index) => (<div key={index}>{s}</div>))
                            : <span>{subtitle}</span>
                    }
                </Typography>
            }
        </Box>
    );
};
